/************
 * Developed by : Shiva Software Solutions
 * Date : 28-06-2021
 * Descriptions : Route Navigation
 * Dependicies : To use @material-ui/core
 ************/
import React, {useContext, useRef} from 'react';
import {renderRoutes} from 'react-router-config';
import {CSSTransition, TransitionGroup} from 'react-transition-group';
import {Switch, useLocation} from 'react-router-dom';
import {AppSuspense} from '../../index';
import routes from '../../../modules';
import Scrollbar from '../Scrollbar';
import AppContext from '../../utility/AppContext';
import PropTypes from 'prop-types';
import AppFooter from '../AppLayout/AppFooter';
import Box from '@material-ui/core/Box';
import {RouteTransition} from '../../../shared/constants/AppEnums';
import AppErrorBoundary from '../AppErrorBoundary';
import IdleTimer from 'react-idle-timer';
import {useDispatch} from 'react-redux';
import {useAuthUser} from '../../utility/AppHooks';
import {AuthType} from '../../../shared/constants/AppEnums';
import {onJWTAuthSignout} from '../../../redux/actions';
const TransitionWrapper = ({children}) => {
  const {rtAnim} = useContext(AppContext);
  const location = useLocation();
  if (rtAnim === RouteTransition.NONE) {
    return <>{children}</>;
  }
  const currentKey = location.pathname.split('/')[1] || '/';
  return (
    <TransitionGroup appear enter exit>
      <CSSTransition
        key={currentKey}
        timeout={{enter: 300, exit: 300}}
        classNames={rtAnim}>
        <Switch location={location}>{children}</Switch>
      </CSSTransition>
    </TransitionGroup>
  );
};

TransitionWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};
const ContentView = () => {
  const dispatch = useDispatch();
  const user = useAuthUser();
  const idleTimer = useRef();
  const [idletime, setIdleTime] = React.useState({
    timeout: 1000 * 60 * 180, //180 minutes timeout
    showModal: false,
    userLoggedIn: false,
    isTimedOut: false,
  });

  const onAction = (e) => {
    setIdleTime({...idletime, isTimedOut: false});
  };

  const onActive = (e) => {
    // this.setState({isTimedOut: false})
    setIdleTime({...idletime, isTimedOut: false});
  };

  const onIdle = (e) => {
    // const isTimedOut = idletime.isTimedOut
    if (idletime.isTimedOut) {
      // alert("timedd pout ")

      if (user && user.authType === AuthType.JWT_AUTH) {
        let pushdata = {
          userId: user.id,
          userCode: user.doctorCode,
          onlineStatus: 'Logout',
          loginType: 'doctor',
        };
        dispatch(onJWTAuthSignout(pushdata));
      }
    } else {
      idleTimer.current.reset();
      setIdleTime({...idletime, isTimedOut: true});
    }
  };
  return (
    <Scrollbar>
      <Box
        display='flex'
        flex={1}
        flexDirection='column'
        className='main-content-view'>
        <AppSuspense>
          <AppErrorBoundary>
            <IdleTimer
              ref={idleTimer}
              element={document}
              onActive={onActive}
              onIdle={onIdle}
              onAction={onAction}
              debounce={250}
              timeout={idletime.timeout}
            />
            <TransitionWrapper>{renderRoutes(routes)}</TransitionWrapper>
          </AppErrorBoundary>
        </AppSuspense>
      </Box>
      <AppFooter />
    </Scrollbar>
  );
};

export default ContentView;
